import { TilesRenderer } from '3d-tiles-renderer/three';
import { Vector3 } from 'three';

type Tile = { engineData?: { boundingVolume?: { distanceToPoint(point: Vector3): number } } };
type ViewErrorTarget = { distanceFromCamera: number };
type CameraInfo = { isOrthographic: boolean; position: Vector3 };

/**
 * TilesRenderer that loads the tiles nearest the view's centre first under an orthographic camera.
 * The library sets every tile's distance to infinity there, as the error doesn't depend on it, so
 * the tiles would load in no particular order.
 */
export class CenteredLoadTilesRenderer extends TilesRenderer {
  calculateTileViewError(tile: Tile, target: ViewErrorTarget) {
    // calculateTileViewError isn't part of the library's typings.
    const prototype = TilesRenderer.prototype as unknown as {
      calculateTileViewError(tile: Tile, target: ViewErrorTarget): void;
    };
    prototype.calculateTileViewError.call(this, tile, target);

    const boundingVolume = tile.engineData?.boundingVolume;
    if (Number.isFinite(target.distanceFromCamera) || !boundingVolume) {
      return;
    }

    // The camera looks straight down, so the distance to its position, in the tiles group frame,
    // grows with the distance from the view's centre
    const { cameraInfo } = this as unknown as { cameraInfo: CameraInfo[] };
    for (const info of cameraInfo) {
      if (info.isOrthographic) {
        target.distanceFromCamera = Math.min(
          target.distanceFromCamera,
          boundingVolume.distanceToPoint(info.position),
        );
      }
    }
  }
}
